<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="设备名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入设备名称" />
      </a-form-model-item>
      <a-form-model-item label="设备编号" prop="number" >
        <a-input v-model="form.number" placeholder="请输入设备编号" />
      </a-form-model-item>
      <a-form-model-item label="设备图片" prop="picture">
        <file-upload type="image" :defaultList="form.imgArr" :count="1" :imgSize="'660*660'"
                     @input="getImg($event, 'picture')"></file-upload>
      </a-form-model-item>

      <a-form-model-item label="心电图 " prop="electrocardiogram" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.electrocardiogram">
          <a-radio :value=0>不显示</a-radio>
          <a-radio :value=1>显示</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="睡眠 " prop="sleep" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.sleep">
          <a-radio :value=0>不显示</a-radio>
          <a-radio :value=1>显示</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="心率 " prop="heartRate" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.heartRate">
          <a-radio :value=0>不显示</a-radio>
          <a-radio :value=1>显示</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="血压 " prop="bloodPressure" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.bloodPressure">
          <a-radio :value=0>不显示</a-radio>
          <a-radio :value=1>显示</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="血糖 " prop="bloodSugar" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.bloodSugar">
          <a-radio :value=0>不显示</a-radio>
          <a-radio :value=1>显示</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="血氧" prop="bloodOxygen" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.bloodOxygen">
          <a-radio :value=0>不显示</a-radio>
          <a-radio :value=1>显示</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="呼吸率" prop="respiratoryRate" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.respiratoryRate">
          <a-radio :value=0>不显示</a-radio>
          <a-radio :value=1>显示</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="温度 " prop="temperature" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.temperature">
          <a-radio :value=0>不显示</a-radio>
          <a-radio :value=1>显示</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="血脂 " prop="bloodFat" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.bloodFat">
          <a-radio :value=0>不显示</a-radio>
          <a-radio :value=1>显示</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="尿酸" prop="uricAcid" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.uricAcid">
          <a-radio :value=0>不显示</a-radio>
          <a-radio :value=1>显示</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="生理周期" prop="physiologicalCycle" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.physiologicalCycle">
          <a-radio :value=0>不显示</a-radio>
          <a-radio :value=1>显示</a-radio>
        </a-radio-group>
      </a-form-model-item>
<!--      <a-form-model-item label="运动标签 多个英文逗号分割" prop="label" >-->
<!--        <a-input v-model="form.label" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->


      <a-form-model-item label="运动标签 " >
        <a-select
          mode="multiple"
          placeholder="全部"
          :value="banse_courseLabel"
          style="width: 100%"
          @change="setCourseList"
        >
          <a-select-option :value="item.name" v-for="(item, index) in base_courseLabelList" :key="index" >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="绑定会员 " >
      <a-select @change="changeSelect" placeholder="全部" show-search :value="form.member"
                option-filter-prop="children" :filterOption="filterOption">
        <a-select-option :value="item.id" v-for="(item, index) in memberList" :key="index">
          {{ item.memberName }}
        </a-select-option>
      </a-select>
      </a-form-model-item>

      <a-form-model-item label="赠送现金券额度" prop="voucher">
        <a-input-number style="width: 200px" :min="0" v-model="form.voucher" placeholder="请输入赠送现金券额度" />
      </a-form-model-item>

      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getVersion, addVersion, updateVersion } from '@/api/device/version'
// import {labelCourse, versionCourse} from "@/api/course/course";
import {courseName} from "@/api/catalogue/catalogue";
// import {listMemberInfo} from "@/api/member/memberInfo";
import {guid} from "@/utils/ruoyi";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      banse_courseLabel:[],
      base_courseLabelList:[],
      courseLabelList:[],
      submitLoading: false,
      formTitle: '',
      memberList: [],
      // 表单参数
      form: {
        id: null,
        imgArr: [],
        memberList: [],

        name: null,
        voucher: null,
        member: null,
        picture: null,

        number: null,

        electrocardiogram: null,

        sleep: null,

        heartRate: null,

        bloodPressure: null,

        bloodSugar: null,

        bloodOxygen: null,

        respiratoryRate: null,

        temperature: null,

        bloodFat: null,

        uricAcid: null,

        physiologicalCycle: null,

        label: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '设备名称不能为空', trigger: 'blur' }
        ],
        number: [
          { required: true, message: '设备编号不能为空', trigger: 'blur' }
        ],
        electrocardiogram: [
          { required: true, message: '心电图 0-不显示 1-显示不能为空', trigger: 'blur' }
        ],
        sleep: [
          { required: true, message: '睡眠 0-不显示 1-显示不能为空', trigger: 'blur' }
        ],
        heartRate: [
          { required: true, message: '心率 0-不显示 1-显示不能为空', trigger: 'blur' }
        ],
        bloodPressure: [
          { required: true, message: '血压 0-不显示 1-显示不能为空', trigger: 'blur' }
        ],
        bloodSugar: [
          { required: true, message: '血糖 0-不显示 1-显示不能为空', trigger: 'blur' }
        ],
        bloodOxygen: [
          { required: true, message: '血氧 0-不显示 1-显示不能为空', trigger: 'blur' }
        ],
        respiratoryRate: [
          { required: true, message: '呼吸率 0-不显示 1-显示不能为空', trigger: 'blur' }
        ],
        temperature: [
          { required: true, message: '温度 0-不显示 1-显示不能为空', trigger: 'blur' }
        ],
        bloodFat: [
          { required: true, message: '血脂 0-不显示 1-显示不能为空', trigger: 'blur' }
        ],
        uricAcid: [
          { required: true, message: '尿酸 0-不显示 1-显示不能为空', trigger: 'blur' }
        ],
        physiologicalCycle: [
          { required: true, message: '生理周期 0-不显示 1-显示不能为空', trigger: 'blur' }
        ],
        label: [
          { required: true, message: '', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    // courseLabelList() {
    //   return this.base_courseLabelList.filter(o => !this.banse_courseLabel.includes(o.name));
    // },
    courseLabel() {
      return this.base_courseLabelList.filter(o => this.banse_courseLabel.includes(o.name)).map(item=>item.id)
    },
  },
  watch: {
  },
  activated () {

  },
  methods: {
    changeSelect(val){
      console.log(val,"val")
      this.form.member = val
    },
    filterOption(input, option) {
      console.log(input, option,"input, option")
      // 重点在这
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.banse_courseLabel = [],
      this.form = {
        id: null,
        imgArr: [],
        picture: null,
        member: null,
        name: null,
        voucher: null,
        number: null,
        electrocardiogram: null,
        sleep: null,
        heartRate: null,
        bloodPressure: null,
        bloodSugar: null,
        bloodOxygen: null,
        respiratoryRate: null,
        temperature: null,
        bloodFat: null,
        uricAcid: null,
        physiologicalCycle: null,
        label: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },







    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      this.getCourseList()
      this.getMemberList()
    },


    /** 查询会员名称 */
    getMemberList() {
      listMemberInfo().then(Response => {
          console.log(Response,"xx")
          this.memberList = Response.data
        }
      )
    },

    //设置多选值
    setCourseList(selectedItems) {
      // console.log(selectedItems)
      this.banse_courseLabel = selectedItems;
      this.
      //这是最终要提交的地址
      console.log(this.courseLabel)
    },
    /** 查询标签名称 */
    getCourseList() {
      versionCourse().then(Response => {
          console.log(Response)
          this.base_courseLabelList = Response.data;
        }
      )
    },


    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.getCourseList()
      this.getMemberList()
      this.formType = 2
      const id = row ? row.id : ids
      getVersion({"id":id}).then(response => {
        this.form = response.data

        let that = this;
        this.form.imgArr = []
        this.form.imgArr.push({
          uid: guid(8, 10),
          name: that.form.picture,
          status: 'done',
          halfUrl: that.form.picture,
          url: that.form.picture,
          path: that.form.picture
        })


        this.open = true
        this.formTitle = '修改'
        //  修改回显:
        let tem_arr = this.form.label.split(",");
        this.banse_courseLabel = this.base_courseLabelList.filter(o => tem_arr.includes(o.id)).map(item=>item.name)
      })
    },
    /** 提交按钮 */
    submitForm: function () {

      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
      this.form.label = this.courseLabel.join(",")
          if (this.form.id !== undefined && this.form.id !== null) {
            updateVersion(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addVersion(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
